// Path: ./src/app/pages/UploadMenu/index.tsx
import { Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ListTableQueryPagination } from "../../components/ListTable/ListTableQueyPagination";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";
import { SearchInput } from "../../components/SearchInputField";
import { UploadMenuModal } from "../../components/UploadMenuModal";
import { adminApiService } from "../../../utils/api";
import {
  GfImage,
  GfImageDto,
  GfMenu,
  GfMenuDto,
  GfMenuTag,
  GfMerchantDto,
  GfStore,
  MuiFilterRequestDto,
  UpdateGfMenuDto,
} from "@swagger/typescript-fetch-goflyer";
// import { saveSplittedFlyerImage } from "../../../utils/FlyerImageSave";
// import { getStoreByMerchantId } from "../../../utils/getStoreByMerchant";
import {
  GridFilterModel,
  GridPaginationModel,
  GridRowSelectionModel,
} from "@mui/x-data-grid";
import { MuiConfirmationModal } from "../../components/MuiConfirmationModal";
import { useTranslation } from "react-i18next";

import { messages } from "../../../locales/messages";
import { GridSortModel } from "@mui/x-data-grid";
import { useLoading } from "../../../contextApi/LoadingContext";
import { toastError, toastSuccess } from "../../../utils/pageUtil/toast";
import { makeStoreDisplayName } from "../../../utils/dtoUtil/makeStoreDisplayName";
import { getStoreByMerchantId } from "../../../utils/getStoreByMerchant";
import { useMenuTagOptions } from "../../../hooks";
import { useStores } from "../../../hooks/useStores";
import { useMerchants } from "../../../hooks/useMerchants";
import { useUploadOrPickImages } from "../../../hooks/useUploadOrPickImages";
import { TableData } from "../../../utils/interface/tableData";
import { useMenuTableColumns } from "./useMenuTableColumns";
import { SetupPageTopAppBar } from "../../../utils/commonStyledComponents/commonStyled";
import { BlackFontTransparentButton } from "../../../utils/commonStyledComponents/commonMuiStyled";
import { GoFlyerAdminContext } from "../../../contextApi/context";
import {
  Container,
  LeftButtonSection,
  RightSearchSection,
  TableWrapper,
} from "./styled";
import { SUPERADMIN } from "../../../utils/constant/stringConstant";
import { useAuthHeaders } from "../../../hooks/useAuthHeaders";
import { useQueryParams } from "../../../hooks/useQueryParams";
import { muiFilterModelHasActiveItems } from "../../../utils/muiGridFilterModel";
import { useLatestRequestGuard } from "../../../hooks/useLatestRequestGuard";
import { guardedListFetch } from "../../../utils/guardedListFetch";

const UploadMenu = () => {
  const { state } = React.useContext(GoFlyerAdminContext);
  const authHeaders = useAuthHeaders();
  const { showLoadingScreen } = useLoading();
  const { t } = useTranslation();

  const [updateMenuItem, setUpdateMenuItem] = useState<UpdateGfMenuDto>();
  const [merchants, setMerchants] = useState<GfMerchantDto[]>();
  const [rowSelectionModel, setRowSelectionModel] =
    useState<GridRowSelectionModel>([]);
  const [menuListData, setMenuListData] = useState<TableData<GfMenu>>();
  const [open, setOpen] = useState(false);
  const [paginationLoading, setPaginationLoading] = useState(false);
  const listRequestGuard = useLatestRequestGuard();
  const [openCreateMenu, setOpenCreateMenu] = useState<boolean>(false);
  const [filterModel, setFilterModel] = useState<GridFilterModel>({
    items: [],
  });
  const { paginationModel, sortModel, handleTableChange, setQueryParams } =
    useQueryParams(100);
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const [isLocalSelected, setIsLocalSelected] = useState<
    "local" | "select" | undefined
  >(undefined);

  const { menuTagOptionList } = useMenuTagOptions();

  const { storesList, isStoreOptionLoading, handleOnStoreSearch } = useStores();
  const { merchantsList, isMerchantOptionLoading, handleOnMerchantSearch } =
    useMerchants();

  const [searchText, _setSearchText] = useState<string | undefined>(undefined);
  const [initialPickedImages, setInitialPickedImages] = useState<GfImageDto[]>(
    [],
  );
  const {
    isUploadingImage,
    handleOnImageFileSelect,
    handleOnRemoveImage,
    setPickedGfImages,
    isDragging,
    getDropZoneProps,
    showReorderModal,
    pendingDropFiles,
    handleReorderConfirm,
    handleReorderCancel,
  } = useUploadOrPickImages({
    onPickedImageChange: (images: GfImage[]) => {
      setUpdateMenuItem((prev) => {
        return {
          ...prev,
          gfImages: images,
        };
      });
    },
    initialPickedImages,
    dragAndDrop: { enabled: true, defaultPath: "flyers" },
  });
  /**
   * Opens a confirmation modal to delete a Upload menu.
   *
   * @param value - The Upload menu data to be deleted.
   */
  const handleOpenDelete = () => {
    setOpen(true);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleCloseCreateMenu = () => {
    setPickedGfImages([]);
    setOpenCreateMenu(false);
    setUpdateMenuItem(undefined);
    setInitialPickedImages([]);
    setIsLocalSelected(undefined);
    setIsEditing(false);
  };

  const handleSaveMenu = async () => {
    if (!updateMenuItem?.name) {
      toastError(`${t(messages.Product_Name())} ${t(messages.is_Empty())}`);
      return;
    }
    if (!updateMenuItem?.stores?.length) {
      toastError(`${t(messages.stores())} ${t(messages.is_Empty())}`);
      return;
    }
    if (!updateMenuItem?.menuTag) {
      toastError(`${t(messages.Tag())} ${t(messages.is_Empty())}`);
      return;
    }
    if (!updateMenuItem?.gfImages || updateMenuItem.gfImages.length === 0) {
      toastError(`${t(messages.gfImages())} ${t(messages.is_Empty())}`);
      return;
    }
    if (!state.gfAdminUser) {
      toastError(
        `${t(messages.There_is_an_error_please_Contact_Administrator())}`,
      );
      return;
    }
    showLoadingScreen(true);
    updateMenuItem.id
      ? await adminApiService.updateOneBaseGfMenuAdminControllerGfMenu(
          updateMenuItem,
          updateMenuItem.id,
          authHeaders,
        )
      : await adminApiService.createOneBaseGfMenuAdminControllerGfMenu(
          {
            ...updateMenuItem, //This is for optional properties
            name: updateMenuItem.name,
            stores: updateMenuItem.stores,
            menuTag: updateMenuItem.menuTag,
            gfImages: updateMenuItem.gfImages,
            rank: updateMenuItem.rank,
            adminUser: state.gfAdminUser,
          },
          authHeaders,
        );
    toastSuccess(t(messages.Menu_Uploaded_Successfully()));
    setUpdateMenuItem(undefined);
    setMerchants(undefined);
    setOpenCreateMenu(false);
    setInitialPickedImages([]);
    await fetchMenuList(paginationModel, sortModel);
    showLoadingScreen(false);
  };

  /**
   * Handles the click event to initiate editing of a menu item.
   *
   * @param value - The EditProps containing menu item details for editing.
   */
  const handleOnClickEdit = async (value: GfMenuDto) => {
    showLoadingScreen(true);
    const menu = await adminApiService.getOneBaseGfMenuAdminControllerGfMenu(
      value.id,
      undefined,
      undefined,
      undefined,
      authHeaders,
    );
    setIsEditing(true);
    setUpdateMenuItem(menu);
    setInitialPickedImages(menu.gfImages || []);
    setOpenCreateMenu(true);

    showLoadingScreen(false);
  };

  const menuTableColumns = useMenuTableColumns(handleOnClickEdit);

  const fetchMenuListWithFilter = async (
    activeFilterModel: GridFilterModel,
  ) => {
    await guardedListFetch(
      listRequestGuard,
      setPaginationLoading,
      async () => {
        const body: MuiFilterRequestDto = {
          filterModel: {
            items: activeFilterModel.items.map((item) => ({
              field: item.field,
              operator: item.operator,
              value: item.value,
              id: item.id,
            })),
            logicOperator: activeFilterModel.logicOperator as any,
            quickFilterValues: activeFilterModel.quickFilterValues,
            quickFilterLogicOperator:
              activeFilterModel.quickFilterLogicOperator as any,
          },
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel: sortModel?.map((s) => ({
            field: s.field,
            sort: s.sort as any,
          })),
        };
        return adminApiService.gfMenuAdminControllerFilterWithMuiGrid(
          body,
          authHeaders,
        );
      },
      (response) => {
        if (!response) return;
        setMenuListData((prev) => ({
          ...prev,
          rows: response.rows,
          total: response.total,
        }));
      },
    );
  };

  const handleFilterModelChange = (newFilterModel: GridFilterModel) => {
    setFilterModel(newFilterModel);
  };

  const fetchMenuList = async (
    gridPaginationModel: GridPaginationModel,
    gridSortModel: GridSortModel,
  ) => {
    await guardedListFetch(
      listRequestGuard,
      setPaginationLoading,
      async () => {
        const conditions = [];
        const storesList =
          state.user?.parsedRoles?.name === SUPERADMIN
            ? []
            : state.user?.stores?.map((value) => {
                return `${value.id}`;
              }) || [];

        if (storesList && storesList.length) {
          conditions.push(`stores.id||$in||${storesList?.join(",")}`);
        }

        return adminApiService.getManyBaseGfMenuAdminControllerGfMenu(
          undefined,
          undefined,
          conditions?.length ? conditions : undefined,
          undefined,
          gridSortModel?.length
            ? [
                `${
                  gridSortModel[0].field
                },${gridSortModel[0]?.sort?.toUpperCase()}`,
              ]
            : [`updatedAt,DESC`],
          undefined,
          gridPaginationModel?.pageSize,
          0,
          gridPaginationModel?.page,
          undefined,
          authHeaders,
        );
      },
      (MenuList) => {
        setMenuListData((prev) => ({
          ...prev,
          rows: MenuList.data,
          total: MenuList?.total,
        }));
      },
    );
  };

  const handleDeleteMenu = async () => {
    if (rowSelectionModel?.length) {
      try {
        setPaginationLoading(true);
        showLoadingScreen(true);
        const result = await rowSelectionModel?.map(async (value) => {
          return await adminApiService.deleteOneBaseGfMenuAdminControllerGfMenu(
            value as string,
            authHeaders,
          );
        });
        await Promise.all(result);

        if (searchText?.trim()?.length) {
          searchMenuFn(); //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) why do we need to call this?
        } else {
          fetchMenuList(paginationModel, sortModel);
        }

        setPaginationLoading(false);
        showLoadingScreen(false);

        handleCancel();
        toastSuccess(t(messages.Successfully_Deleted_Menus()));
      } catch (error) {
        setPaginationLoading(false);
        console.log("error", error);
        toastSuccess(
          t(messages.There_is_an_error_please_Contact_Administrator()),
        );
      }
    }
  };

  const searchMenuFn = async () => {
    if (searchText?.length) {
      const searchValue = searchText.trim().toLowerCase();
      setQueryParams({ page: 1, pageSize: 100 });
      await guardedListFetch(
        listRequestGuard,
        setPaginationLoading,
        async () =>
          adminApiService.gfMenuAdminControllerSearch(
            `${searchValue}`,
            1 as number,
            100 as number,
            authHeaders,
          ),
        (response) => {
          const data = {
            ...menuListData,
            rows: response?.data,
            total: response?.total,
          };
          setMenuListData(data);
        },
      );
    } else if (searchText != undefined) {
      setQueryParams({ page: 1, pageSize: 10 });
    }
  };

  useEffect(() => {
    //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) use another way to debounce
    const debounce = setTimeout(() => {
      searchMenuFn();
    }, 1000);

    return () => {
      clearTimeout(debounce);
    };
  }, [searchText]);

  useEffect(() => {
    setMenuListData({
      columns: menuTableColumns,
    });
  }, []);

  useEffect(() => {
    const hasActiveFilters = muiFilterModelHasActiveItems(filterModel);
    if (hasActiveFilters) {
      fetchMenuListWithFilter(filterModel);
    } else if (searchText?.trim()?.length) {
      searchMenuFn();
    } else {
      fetchMenuList(paginationModel, sortModel);
    }
  }, [paginationModel, sortModel, filterModel]);

  return (
    <Container data-testid="upload-menu-view-page">
      <SetupPageTopAppBar>
        <LeftButtonSection>
          <Stack direction="row" spacing={2}>
            <BlackFontTransparentButton
              variant="text"
              startIcon={
                <UploadFileIcon style={{ color: "#ff8038", fontSize: 25 }} />
              }
              onClick={() => {
                // open create menu modal
                setOpenCreateMenu(true);
              }}
              data-testid="create-button"
            >
              {t(messages.Create())}
            </BlackFontTransparentButton>
            <BlackFontTransparentButton
              variant="text"
              startIcon={
                <DeleteIcon
                  style={{
                    color: "#ff8038",
                    fontSize: 25,
                    opacity: !rowSelectionModel?.length ? 0.5 : 1,
                  }}
                />
              }
              disabled={!rowSelectionModel?.length}
              onClick={handleOpenDelete}
              data-testid="delete-button"
            >
              {t(messages.Delete())}
            </BlackFontTransparentButton>
          </Stack>
        </LeftButtonSection>
        <RightSearchSection>
          <SearchInput></SearchInput>
        </RightSearchSection>
      </SetupPageTopAppBar>
      <TableWrapper>
        <ListTableQueryPagination
          loadFailed={listRequestGuard.loadFailed}
          columns={menuListData?.columns}
          rows={menuListData?.rows}
          total={paginationLoading ? 0 : menuListData?.total}
          paginationModel={paginationModel}
          sortModel={sortModel}
          onTableChange={handleTableChange}
          isLoading={paginationLoading}
          handleRowSelection={(value) => {
            setRowSelectionModel(value);
          }}
          dynamicHeightAdjuster={210}
          filterModel={filterModel}
          onFilterModelChange={handleFilterModelChange}
        />
      </TableWrapper>
      {openCreateMenu ? (
        <UploadMenuModal
          menuTagOptionList={menuTagOptionList?.map((tag) => ({
            value: tag,
            label: tag.name,
          }))}
          merchantOptionList={merchantsList?.map((merchant) => ({
            value: merchant,
            label: merchant.name,
          }))}
          handleLocalUpload={(e) => handleOnImageFileSelect(e, "flyers")}
          isUploadingImage={isUploadingImage}
          flyerImages={updateMenuItem?.gfImages}
          handleMenuCancelButton={handleOnRemoveImage}
          isLocalImageSelect={isLocalSelected}
          storeOptionList={storesList?.map((store) => ({
            value: store,
            label: makeStoreDisplayName(store),
          }))}
          store={updateMenuItem?.stores?.map((store) => ({
            value: store,
            label: store.merchant.name,
          }))}
          merchant={merchants?.map((merchant) => ({
            value: merchant,
            label: merchant.name,
          }))}
          Name={updateMenuItem?.name}
          menuTag={updateMenuItem?.menuTag}
          rankValue={updateMenuItem?.rank}
          isEditing={isEditing}
          showDateRange={false}
          flyerTagTitle={t(messages.Menu_Tag()) as string}
          DropImageHereTitle={
            t(messages.Drop_or_click_to_select_picture()) as string
          }
          handleName={(event) => {
            if (event) {
              setUpdateMenuItem({
                ...updateMenuItem,
                name: event.target.value,
              });
            }
          }}
          handleRank={(event) => {
            if (event) {
              setUpdateMenuItem({
                ...updateMenuItem,
                rank: parseInt(event.target.value),
              });
            }
          }}
          handleMerchant={async (merchants: GfMerchantDto[] | undefined) => {
            if (merchants && merchants.length > 0) {
              setMerchants(merchants); //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) can just move to child state
              const stores = await getStoreByMerchantId(
                merchants[0].id as string,
              );
              stores &&
                setUpdateMenuItem({
                  ...updateMenuItem,
                  stores: stores,
                });
            } else {
              setMerchants(undefined);
              setUpdateMenuItem({
                ...updateMenuItem,
                stores: undefined,
              });
            }
          }}
          handleMenuTag={(
            menuTag: GfMenuTag[] | undefined, //TODO: (if you touch code here, please refactor. if you don't know the issue, please talk to me) undefined doesn't make sense here, will fix later
          ) => {
            setUpdateMenuItem({
              ...updateMenuItem,
              menuTag: menuTag,
            });
          }}
          handleStore={(stores: GfStore[] | undefined) => {
            setUpdateMenuItem({
              ...updateMenuItem,
              stores: stores,
            });
          }}
          onClose={handleCloseCreateMenu}
          onSubmit={handleSaveMenu}
          handleOnStoreSearch={handleOnStoreSearch}
          handleOnMerchantSearch={handleOnMerchantSearch}
          isOptionLoading={isStoreOptionLoading}
          isOptionLoadingMerchant={isMerchantOptionLoading}
          getDropZoneProps={getDropZoneProps}
          isDragging={isDragging}
          showReorderModal={showReorderModal}
          pendingDropFiles={pendingDropFiles}
          handleReorderConfirm={handleReorderConfirm}
          handleReorderCancel={handleReorderCancel}
        />
      ) : (
        <></>
      )}
      <MuiConfirmationModal
        open={open}
        handleCancel={handleCancel}
        handleConfirm={handleDeleteMenu}
        title={`${t(messages.Delete_Confirmation())}`}
        description={`
        ${t(messages.Are_you_sure_you_want_to_delete_These())} ${t(
          messages.Selected_Menus(),
          { count: rowSelectionModel.length },
        )}?  ${t(messages.This_action_cannot_be_undone())}.
      `}
      />
    </Container>
  );
};

export default UploadMenu;
